<p *ngFor="let toRead of messages" [attr.aria-live]="toRead.politeness">
	{{ toRead.message }}
</p>
